var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
/**
 * Hook will return `null` when it is first created. After the internal `useEffect`
 * hook runs for the first time after the initial render, THEN it will return
 * the actual window size and update the value every time the window size changes.
 *
 * This behavior is necessary to support SSR as the `window` object is
 * not defined when rendering components on the server.
 */
export var useWindowWidth = function () {
    var _a = __read(React.useState(null), 2), width = _a[0], setWidth = _a[1];
    React.useEffect(function () {
        setWidth(window.innerWidth);
        var handleResize = function handleResize() {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return width;
};
//# sourceMappingURL=index.js.map